import { Property, PropertyBusinessType } from 'models/Properties';
import { HOSTFULLY_ASSIST_PRICE_PER_PROPERTY } from './HostfullyAssistDetails.constants';

type AssistPricedProperty = Pick<
  Property,
  'uid' | 'businessType' | 'numberOfSubUnits' | 'unitTypes'
>;

const getAssistBillableUnitsCount = (property: AssistPricedProperty): number =>
  property.businessType === PropertyBusinessType.HOTEL
    ? property.unitTypes?.reduce(
        (total, unitType) => total + (unitType.units?.length ?? 0),
        0,
      ) ?? 0
    : 1 + (property.numberOfSubUnits ?? 0);

/**
 * The count will take into consideration the different kinds of properties:
 * - Standalone: 1;
 * - Master: 1 + numberOfSubUnits;
 * - Multi-unit: number of units across unit types.
 */
export const getAssistSelectedUnitsCount = (
  selectedProperties: string[],
  properties: AssistPricedProperty[],
): number =>
  selectedProperties.reduce((total, uid) => {
    const property = properties.find((p) => p.uid === uid);
    return total + (property ? getAssistBillableUnitsCount(property) : 0);
  }, 0);

/**
 * The total price will take into consideration the different kinds of properties:
 * - Standalone: HOSTFULLY_ASSIST_PRICE_PER_PROPERTY;
 * - Master: HOSTFULLY_ASSIST_PRICE_PER_PROPERTY + (numberOfSubUnits * HOSTFULLY_ASSIST_PRICE_PER_PROPERTY);
 * - Multi-unit: number of units across unit types * HOSTFULLY_ASSIST_PRICE_PER_PROPERTY.
 */
export const getAssistTotalPrice = (
  selectedProperties: string[],
  properties: AssistPricedProperty[],
): number =>
  getAssistSelectedUnitsCount(selectedProperties, properties) *
  HOSTFULLY_ASSIST_PRICE_PER_PROPERTY;
